// extracted by mini-css-extract-plugin
export default {"root":"Adsense_root__ZlutX","placeholder":"Adsense_placeholder__K7Q0B","leaderboard":"Adsense_leaderboard__ye9oG","ads":"Adsense_ads__eDJ-I"};